<img src="../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>

<div style="margin-top:10px;"><span style="margin-left:20px;font-size:18px;font-weight: bold;;">Parker Import Validation Errors</span></div>
<div>

    <div style="margin-top:20px;margin-left:20px;margin-bottom:15px;margin-right:10px;">
      <p><span>Number of Errors: <strong>{{errorList.length}}</strong></span></p>
      <span><strong>Error(s):</strong></span>
      @for (item of errorList; track $index) {
        <p>{{$index + 1}}. {{item.message}}</p>
        @if($index < (errorList.length -1)){
            <hr />
        }
      }
</div>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>

